import styled from 'styled-components'
import { Dropdown } from './index'

const SectorDropdown = styled(Dropdown).attrs({
  items: [
    { text: 'Public', value: 'GOVERNMENT' },
    { text: 'Private', value: 'INDEPENDENT' },
    { text: 'Catholic', value: 'CATHOLIC' },
  ],
})``

export { SectorDropdown }
